var WDN = WDN || {};

if (typeof WDN.Pagination === "undefined") {
  WDN.Pagination = (function () {
    class Pagination extends HTMLElement {
      constructor() {
        super();
      }

      setURLParam() {
        return;
        this.searchParams = new URLSearchParams(window.location.search);
        this.searchParams.set(this.paramName, this.nextPage);
        window.history.pushState("", "", "?" + this.searchParams.toString());
      }

      getURLToFetch() {
        this.searchParams = new URLSearchParams(window.location.search);
        this.searchParams.set("section_id", this.sectionID);
        return this.partURL + "&" + this.searchParams.toString();
      }

      onFetchError() {
        //
      }

      removeSelf() {
        this.parentNode.remove();
      }

      onFetchSuccess(res) {
        this.domParser = new DOMParser();
        var parsedResponse = this.domParser.parseFromString(res, "text/html");
        var removePrevious = false;
        var output = "";

        // If next is clicked remove previous button from parsed response
        if (this.type === "next" || this.totalPages === this.nextPage) {
          removePrevious = true;
        }

        // If last page - remove previous pagination button
        if (removePrevious) {
          var previousButton = parsedResponse.querySelector("[data-type='previous']");
          if (previousButton) previousButton.remove();
        }

        output = parsedResponse.querySelector(".shopify-section").innerHTML;

        // If previous is clicked - replace content with response
        if (this.type === "previous") {
          this.output.innerHTML = output;
          // Output distance from top
          var distanceFromTop = window.pageYOffset + this.output.getBoundingClientRect().top;
          // Header height
          var headerHeight = parseInt(WDN.CSSVariable.get("--header-height"));
          // Announcement height
          var announcementHeight = parseInt(WDN.CSSVariable.get("--announcement-height"));

          // Scroll to output container
          window.scroll({
            top: distanceFromTop - headerHeight - announcementHeight,
            behavior: "smooth",
          });
          return;
        }

        // Next is clicked - append response to the content
        this.output.insertAdjacentHTML("beforeend", output);
        this.removeSelf();
      }

      fetchLayout() {
        WDN.Request.Get({
          url: this.getURLToFetch(),
          onSuccess: this.onFetchSuccess.bind(this),
          onErrror: this.onFetchError.bind(this),
        });
      }

      onClick() {
        this.setURLParam();
        this.fetchLayout();
      }

      init() {
        this.onClickBound = this.onClick.bind(this);
        this.addEventListener("click", this.onClickBound);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onClickBound);
      }

      // Code starts here
      connectedCallback() {
        this.type = this.getAttribute("data-type");
        this.outputID = this.getAttribute("data-output-id");
        this.output = document.querySelector("[data-pagination-output='" + this.outputID + "']");
        this.nextPage = parseInt(this.getAttribute("data-next-page"));
        this.totalPages = parseInt(this.getAttribute("data-total-pages"));
        this.paramName = this.getAttribute("data-param-name");
        this.sectionID = this.getAttribute("data-section-id");
        this.partURL = this.getAttribute("data-part-url");
        if (!this.output) {
          console.warn("No pagination output");
          return;
        }

        this.init();
      }
    }

    customElements.define("pagination-element", Pagination);
    return {};
  })();
}
